/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {EmailStepError} from "./types";

export function translateEmailStepError(error: string | EmailStepError | null | undefined,
                                        generalError: boolean, includeStepLabel?: boolean): string | null {
    if (!error) return null;
    if (typeof error === 'string') {
        if (error === 'invoice_attachment')
            if (generalError) return 'Eén of meer e-mails bevat niet de factuur als bijlage, volgens het beleid van ' +
                'Bol moet de factuur als bijlage meegezonden worden. Het kan zijn dat Bol deze e-mails blokkeert en je ' +
                'loopt het risico op beleidspuntenaftrek.';
            else return 'Deze e-mail bevat niet de factuur als bijlage.'
        else if (error === 'duplicate_mail')
            if (generalError) return 'Er worden meerdere e-mails naar dezelfde klanten verzonden, volgens het beleid ' +
                'van Bol mag iedere klant maar één e-mail ontvangen. Het kan zijn dat Bol deze e-mails blokkeert en je ' +
                'loopt het risico op beleidspuntenaftrek.'
            else return 'Er wordt al een andere e-mail naar deze klanten verzonden. Stuur maximaal 1 mail per 1 order.'
    } else {
        if (error.reason === 'content') return (includeStepLabel ? `${error.step_label}: ` : '') + error.error;
        else if (error.reason === 'overlap') return (includeStepLabel ? `${error.step1_label}: ` :
            '') + `Deze e-mail heeft overlap met e-mail '${error.step2_label}'. 
        Stuur maximaal 1 mail per 1 order`
    }
    return null;
}